import axios from 'axios' // 引入axios
import qs from 'qs' // 引入qs

// axios 默认配置  更多配置查看Axios中文文档
// axios.defaults.timeout = 5000 // 超时默认值
// axios.defaults.baseURL = '/api' // 默认baseURL
// axios.defaults.responseType  = 'json'         // 默认数据响应类型
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
// axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'

/**
 * post 方法封装
 * @param url
 * @param data
 * @returns {Promise}
 */
export function ajaxPost (url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, qs.stringify(data, { arrayFormat: 'repeat' }))
            .then(response => {
                resolve(response.data)
            }, err => {
                reject(err)
                console.log(err)
            })
    })
}

export function ajaxPut (url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.put(url, qs.stringify(data, { arrayFormat: 'repeat' }))
            .then(response => {
                resolve(response.data)
            }, err => {
                reject(err)
                console.log(err)
            })
    })
}

/**
 * get 方法封装
 * @param url
 * @param data
 * @returns {Promise}
 */
export function ajaxGet (url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {params: data})
            .then(response => {
                resolve(response.data)
            }, err => {
                reject(err)
            })
    })
}
